{
  "name": "@turnercode/cdp-psm-core",
  "version": "4.4.0",
  "description": "Prism core functions",
  "private": true,
  "main": "dist/psm.legacy.min.umd.cjs",
  "module": "dist/psm.legacy.min.umd.mjs",
  "exports": {
    ".": {
      "import": "./dist/psm.legacy.min.umd.mjs",
      "require": "./dist/psm.legacy.min.umd.cjs"
    },
    "./web": {
      "import": "./dist/psm.legacy.min.umd.mjs",
      "require": "./dist/psm.legacy.min.umd.cjs"
    },
    "./rn": {
      "import": "./dist/psm-rn.mjs",
      "require": "./dist/psm-rn.cjs"
    },
    "./src/*": "./src/*",
    "./package.json": "./package.json"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/turnercode/cdp.git",
    "directory": "packages/psm-core"
  },
  "author": "The CDP Development Team <CDP-TECH-TEAM@warnermedia.com>",
  "license": "UNLICENSED",
  "scripts": {
    "build": "tsup --minify && webpack --config webpack.es5.config.js",
    "build:modern": "tsup --minify",
    "build:es5": "webpack --config webpack.es5.config.js",
    "test:es5": "pnpm build:es5 && pnpm exec es-check es5 dist/psm.es5.min.umd.js",
    "clean": "rm -rf .turbo && rm -rf node_modules && rm -rf dist",
    "lint": "TIMING=1 eslint src --fix",
    "test": "jest"
  },
  "devDependencies": {
    "@babel/core": "^7.23.0",
    "@babel/plugin-transform-runtime": "^7.23.0",
    "@babel/preset-env": "^7.23.0",
    "@babel/preset-typescript": "^7.23.0",
    "@babel/runtime": "^7.23.0",
    "@iabtcf/cmpapi": "^1.5.3",
    "@iabtcf/core": "^1.5.3",
    "@segment/localstorage-retry": "^1.3.0",
    "@turnercode/cdp-cookie": "workspace:*",
    "@turnercode/cdp-feature-flag-client": "workspace:*",
    "@turnercode/cdp-prism-module-telemetry": "workspace:*",
    "@turnercode/eslint-config-cdp": "workspace:*",
    "@turnercode/scripts": "workspace:*",
    "@turnercode/tsconfig": "workspace:*",
    "@turnercode/types": "workspace:*",
    "babel-loader": "^9.1.3",
    "core-js": "^3.23.4",
    "es-check": "^7.1.2",
    "terser-webpack-plugin": "^5.3.14",
    "tsup": "^6.1.3",
    "uuid": "^8.3.2",
    "webpack": "^5.89.0",
    "webpack-cli": "^5.1.4"
  },
  "jest": {
    "preset": "@turnercode/scripts/jest/node",
    "testEnvironment": "jsdom"
  }
}
